import jspb from 'google-protobuf';
import moment from 'moment';
import moment_tz from 'moment-timezone';
import { FontInfo, Lookback, LookbackType, MnmIds } from './Constants';
import {StringTable} from '../StringTable';
import { Dimensions } from 'react-native';
import { Text } from 'react-native';

//var moment = require('moment-timezone');

export default class Utilities
{
    static WIDTH = Utilities.GetDefWidth();
    // public static oTxt : Text | null;
    public static sTxt : string = "";
    public static iTxt : number = 0;

    /*   -----------------------------------------------------------------   */

    static sTimeZone : string = //new Date().toLocaleDateString(undefined, {day:'2-digit',timeZoneName: 'short' }).substring(4);
                                moment_tz().tz(moment_tz.tz.guess()).
                                format('z');

    /*   -----------------------------------------------------------------   */

    static GetDefWidth()
    {
    
    let iW = Dimensions.get('window').width;

    if (iW > 350)
      {
      return(350);
      }
    
    iW -= 10;  

    if (iW < 250)
      iW = 250;

    return(iW);
    }

    /*   -----------------------------------------------------------------   */

    static setTz()
    {
      Utilities.sTimeZone = //new Intl.DateTimeFormat('en', {day:'2-digit',timeZoneName: 'short' }).format(new Date()).substring(4);
                            //new Date().toLocaleDateString(undefined, {day:'2-digit',timeZoneName: 'short' }).substring(4);
                            moment_tz().tz(moment_tz.tz.guess(true)).
                            format('z');
                            //alert(Utilities.sTimeZone);
    }

    /*   -----------------------------------------------------------------   */

    static round(num    : number, 
                 places : number)
    {
      const x = Math.pow(10,places);
      return Math.round(num * x) / x;
    }
        
    /*   -----------------------------------------------------------------   */

    static FindItem(www      : any,
                    token    : string) : number
    {
      for (let i = 0; i < www.length; i++)
        if (www[i].token == token)
          return(i);
  
    return(-1);
    }

    /*   -----------------------------------------------------------------   */

    static FindAndDeleteItem(www   : any,
                             sVal  : string) : boolean
    {
    for (let i = 0; i < www.length; i++)
      {
      if (www[i].token == sVal)
        {
        www.splice(i, 1);
        return(true);
        }
      }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    static FindAndDeleteString(www   : string[],
                               sVal  : string) : boolean
    {
    for (let i = 0; i < www.length; i++)
      {
      if (www[i] == sVal)
        {
        www.splice(i, 1);
        return(true);
        }
      }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    static FindString(www   : string[],
                      sVal  : string) : number
    {
    for (let i = 0; i < www.length; i++)
      {
      if (www[i] == sVal)
        {
        return(i);
        }
      }

    return(-1);
    }

    /*   -----------------------------------------------------------------   */

    static FindAny(www   : any[],
                   sVal  : any) : number
    {
    for (let i = 0; i < www.length; i++)
      {
      if (www[i] == sVal)
        {
        return(i);
        }
      }

    return(-1);
    }

    /*   -----------------------------------------------------------------   */

    static FindAndDeleteAny(www   : any[],
                            sVal  : any) : boolean
    {
    for (let i = 0; i < www.length; i++)
      {
      if (www[i] == sVal)
        {
        www.splice(i, 1);
        return(true);
        }
      }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    static GetString(keys   : Array<any>, 
                     values : Array<any>) : string
    {
    var str1 = "";

    for (let i = 0; i < keys.length; i++)
    {
    str1 += keys[i] + ":" + values[i] + " ";
    }

    return(str1);
    }

    /*   -----------------------------------------------------------------   */

    static ProcessMsg(bytes) : any[][]
    {
        var reader   = new jspb.BinaryReader(bytes);
        var keys     = new Array();
        var values   = new Array();
        var template = 0;
        var token    = new Array();
    
        while (reader.nextField())
        {
         if (reader.isEndGroup())
           break;
    
         var tag      = reader.getFieldNumber();
         var wireType = reader.getWireType();
    
        //field-type to wire-type mapping
    
        //  case fieldTypes.INT32:
        // case fieldTypes.INT64:
        // case fieldTypes.UINT32:
        // case fieldTypes.UINT64:
        // case fieldTypes.SINT32:
        // case fieldTypes.SINT64:
        // case fieldTypes.BOOL:
        // case fieldTypes.ENUM:
        // case fieldTypes.VHASH64:
        //   return wireTypes.VARINT;
    
        // case fieldTypes.DOUBLE:
        // case fieldTypes.FIXED64:
        // case fieldTypes.SFIXED64:
        // case fieldTypes.FHASH64:
        //   return wireTypes.FIXED64;
    
        // case fieldTypes.STRING:
        // case fieldTypes.MESSAGE:
        // case fieldTypes.BYTES:
        //   return wireTypes.DELIMITED;
    
        // case fieldTypes.FLOAT:
        // case fieldTypes.FIXED32:
        // case fieldTypes.SFIXED32:
        //   return wireTypes.FIXED32;
    
        // case fieldTypes.INVALID:
        // case fieldTypes.GROUP:
        // default:
        //   return wireTypes.INVALID;
    
         switch(wireType)
         {
         case 0: //Varint
            keys.push(tag);
            values.push(reader.readInt32());
    
            if (tag == 154467)
              template = values[values.length - 1];
          break;
    
          case 1: //Fixed64 - double and fixed64
            keys.push(tag);
            values.push(reader.readDouble());
            //values.push(reader.readFixed64());
            break;
    
          case 2: //LengthDelimited
            keys.push(tag);
            values.push(reader.readString());
    
            if (tag == 132760 || tag == 110100)
              token.push(values[values.length - 1]);
    
              break;
    
          case 5: //Fixed32 = 5 - float and fixed32
            keys.push(tag);
            values.push(reader.readFixed32());
            break;
    
          case 3: //StartGroup = 3,
          case 4: //EndGroup = 4,
    
          default:
          try {
              reader.skipField();
              }
          catch{}
    
          break;
        }
    
       }
    
      return [[template], token, keys, values];
      }

    /*   -----------------------------------------------------------------   */

    static GetMergedMsg(...args) : Uint8Array
    {
      var writer = new jspb.BinaryWriter();
    
      for (let i = 0; i < arguments.length; i += 2)
      {

        if (arguments[i+1] == undefined)
          {
          continue;  //this disallows adding *field only* in the request
          }

        if (typeof(arguments[i+1]) === 'number')
          {
          switch(arguments[i])
            {
            case MnmIds.MNM_PRICE_TO_FILL:
            case MnmIds.MNM_TRIGGER_PRICE:
            case MnmIds.MNM_MARKET_DEPTH_PRICE:
              writer.writeDouble(arguments[i], arguments[i+1]);
              break;
            default:
              writer.writeInt32(arguments[i], arguments[i+1]);
              break;
            }
          }
        else if (typeof(arguments[i+1]) === 'boolean')
          writer.writeBool(arguments[i], arguments[i+1]);
        else
          writer.writeString(arguments[i], arguments[i+1]);
      }
      
      //new-type
      //return writer.getResultBuffer();

      var two = writer.getResultBuffer();
      var one = Utilities.intToByteArray(two.length);
    
      var merged = new Uint8Array(one.length + two.length);
      merged.set(one);
      merged.set(two, one.length);
    
      return(merged);
    }    

    /*   -----------------------------------------------------------------   */

    static MergeMsg(oMsg1 : Uint8Array | null, oMsg2 : Uint8Array) : Uint8Array
    {
      if (oMsg1 == null)
        return(oMsg2);
        
      var merged = new Uint8Array(oMsg1.length + oMsg2.length);  
      merged.set(oMsg1);
      merged.set(oMsg2, oMsg1.length);
      return(merged);
    }


    /*   -----------------------------------------------------------------   */

    static GetKeyValueString(keys   : Array<any>, 
                             values : Array<any>) : string
    {

    if (StringTable.DEBUG == false)
      return("");

    var str1 = "";

    for (let i = 0; i < keys.length; i++)
      {
      str1 += keys[i] + ":" + values[i] + " ";
      }

    return(str1);
    }

    /*   -----------------------------------------------------------------   */

    static GetKeyValueStringForce(keys   : Array<any>, 
                                  values : Array<any>) : string
    {
    var str1 = "";

    for (let i = 0; i < keys.length; i++)
      {
      str1 += keys[i] + ":" + values[i] + " ";
      }

    return(str1);
    }

    /*   -----------------------------------------------------------------   */

    static GetKeyValueMapString(oMap : Map<any, any>) : string
    {
    if (StringTable.DEBUG == false)
      return("");

    var str1 = "";

    for (var [k, v] of oMap.entries()) 
      str1 += k + " ";

    return(str1);
    }

    /*   -----------------------------------------------------------------   */

    static IsPresent(iVal     : number,
                     iEnumVal : number)
    {
    return (  (iVal & iEnumVal) === iEnumVal );
    }

    /*   -----------------------------------------------------------------   */    

    static GetCurrTime()
    {
    var m_date = new Date(Date.now());

    return( Utilities.formatDate(m_date) + " " + 
            Utilities.formatTimeMS(m_date) );
    }

    /*   -----------------------------------------------------------------   */    

    static Sendlog(sMsg : string)
    {
     if (StringTable.DEBUG == false)
      return;
      
     var m_date = new Date(Date.now());

    let sT = Utilities.formatDate(m_date) + " " + 
         Utilities.formatTimeMS(m_date) + ": " + sMsg;

    console.log (sT);

    if (Utilities.iTxt > 50)
      {
      Utilities.sTxt = "";
      Utilities.iTxt = 0;
      }

    Utilities.sTxt = Utilities.sTxt + "\n\r" + sT;
    Utilities.iTxt++;

    // if (Utilities.oTxt?.forceUpdate)
    //   Utilities.oTxt?.forceUpdate();
    }

        /*   -----------------------------------------------------------------   */
    
    static formatNumber(m_number) : string
    {
    if (m_number < 10)
        return('00' + m_number);
    else if (m_number < 100)
        return('0' + m_number);
    else
        return(m_number.toString());
    }

    /*   -----------------------------------------------------------------   */

    static formatDateDDMMYYYY(m_date) : string
    {
    var dd   = m_date.getDate();
    var mm   = m_date.getMonth() + 1; //January is 0!
    var yyyy = m_date.getFullYear();

    if (dd < 10)
        dd = '0' + dd;

    if (mm < 10)
        mm = '0' + mm;

    var date =  dd + "/" + mm + "/" + yyyy;
    return date.toString();
    }

    /*   -----------------------------------------------------------------   */

    static formatDate(m_date) : string
    {
    var dd   = m_date.getDate();
    var mm   = m_date.getMonth() + 1; //January is 0!
    var yyyy = m_date.getFullYear();
    
    if (dd < 10)
        dd = '0' + dd;
    
    if (mm < 10)
        mm = '0' + mm;
    
    var date =  dd + "/" + mm + "/" + yyyy;
    return date.toString();
    }

    /*   -----------------------------------------------------------------   */

    static GetStartTime(iMinutes   : number,
                        bCCYYMMDD? : boolean) : number
    {
      let iStart  = new Date((Math.trunc(Date.now()/1000) - (iMinutes * 60)) * 1000);
      
      
      if (bCCYYMMDD == true)
        {
        let m = moment(iStart);
        let s = m.format("yyyyMMDD");
        return(Number.parseInt(s));
        }
      else
        return Math.trunc(iStart.getTime()/1000) ;
        
      // if (iMinutes > 500000)//60)
      //   {
      //   let iStart2 = new Date(iStart.getFullYear(),
      //                          iStart.getMonth(),
      //                          iStart.getDate(),
      //                          18);

      //   return Math.trunc(iStart2.getTime()/1000) ;
      //   }
      // else
      //   return Math.trunc(iStart.getTime()/1000) ;
      
    //   var yesterday = new Date(m_date.getFullYear(),
    //                            m_date.getMonth(),
    //                            m_date.getDate() - 1,
    //                            18);
    
    //  return Math.trunc(yesterday.getTime()/1000);
    }

    /*   -----------------------------------------------------------------   */

    static getDateStart(m_date : number) : number
    {
      let yday = new Date((Math.trunc(m_date/1000) - 86400) * 1000);

      let yday2 = new Date(yday.getFullYear(),
                           yday.getMonth(),
                           yday.getDate(),
                           18);

      return Math.trunc(yday2.getTime()/1000) ;
      
    //   var yesterday = new Date(m_date.getFullYear(),
    //                            m_date.getMonth(),
    //                            m_date.getDate() - 1,
    //                            18);
    
    //  return Math.trunc(yesterday.getTime()/1000);
    }

    /*   -----------------------------------------------------------------   */

    static intToByteArray (value)
    {
    return [((value >>> 24) | 0), 
            ((value >>> 16) | 0), 
            ((value >>>  8) | 0), 
             (value | 0)];
    }

    /*   -----------------------------------------------------------------   */

    static formatTimeFromSsboe(iSsboe : number,
                               sFmt   : string) : string
    {
    var m = moment(iSsboe * 1000);
    var s = m.format(sFmt);

    return(s);
    }

    /*   -----------------------------------------------------------------   */

    static FormatLookBackTime(iTime : number,
                              oLB   : Lookback) : string
    {
    if (oLB.DateOnly)
      {
      var m = moment(iTime.toString(), 'YYYYMMDD')
      var s = m.format(oLB.Fmt);

      return(s);
      }
    else
      {
      var m = moment(iTime * 1000);
      var s = m.format(oLB.Fmt);

      return(s);
      }
    }

    /*   -----------------------------------------------------------------   */

    static FormatYYYYMMDD(sDate : string)
    {
    var m = moment(sDate, 'YYYYMMDD')
    var s = m.format('ddd, MMM DD');

    return(s);
    }

    /*   -----------------------------------------------------------------   */

    static FormatYYYYMMDD_EVT(sDate : string)
    {
    let m    = moment(sDate, 'YYYYMMDD')
    let s    = m.format('ddd, MMM DD');
    let s_dt = m.format('MMM DD');

    
    let utc_now   = moment.utc();
    let utc_year  = utc_now.year(); //.getUTCFullYear();
    let utc_month = utc_now.month(); // getUTCMonth();
    let utc_day   = utc_now.date(); //getUTCDay();

    //var utc     = moment(utc_now.getUTCFullYear() + utc_now.getUTCMonth() + utc_now.getUTCDay(), 'YYYYMMDD')
    
    let m_utc = moment({year: utc_year, month: utc_month, day: utc_day});

    let diff    = m.diff(m_utc, 'days');

    return({sFmt:s, sFmtDt:s_dt, iDiff:diff});
    }

    /*   -----------------------------------------------------------------   */

    static FormatTimeFromSsboe(iSsboe : number)
    {
    var m = moment(iSsboe * 1000)
    var s = m.format('h:mma');

    return(s);
    }

    /*   -----------------------------------------------------------------   */

    static FormatDateFromSsboe(iSsboe : number)
    {
    var m = moment(iSsboe * 1000)
    var s = m.format('ddd, MMM DD');

    return(s);
    }

    /*   -----------------------------------------------------------------   */

    static processToken(sToken : string) : string[]
    {
      if (sToken == "" || sToken == null)
        return([]);

      let iIndex = sToken.lastIndexOf(".");

      if (iIndex < 0)
        return([]);

      let sSymbol   = sToken.substring(0, iIndex);
      let sExchange = sToken.substring(iIndex + 1, sToken.length);

      if (sSymbol == "" || sExchange == "")
        return([]);
      else
        {
        //console.log("Processed " + sSymbol + "<>" + sExchange);  
        return([sSymbol, sExchange]);
        }
    }

  /*   ---------------------------------------------------------------------   */

    // static formatTimeFromType(iTimeValue : number,
    //                           lookback)
    // {
    //   switch (iType)
    //     {
    //     case LookbackType.Year:
    //       return(Utilities.formatTimeFromSsboe(iSsboe, "Do MMM YYYY"));          
    //     case LookbackType.Month:
    //       return(Utilities.formatTimeFromSsboe(iSsboe, "Do MMM YYYY"));
    //     case LookbackType.Week:
    //       return(Utilities.formatTimeFromSsboe(iSsboe, "Do MMM ddd"));
    //     case LookbackType.Day:
    //       return(Utilities.formatTimeFromSsboe(iSsboe, "Do MMM h:mma"));
    //     case LookbackType.Hour:
    //       return(Utilities.formatTimeFromSsboe(iSsboe, "Do MMM h:mma"));          
    //     case LookbackType.Min:
    //       return(Utilities.formatTimeFromSsboe(iSsboe, "h:mma"));
    //     }
    // }

    /*   -----------------------------------------------------------------   */

    static formatTimeMS(m_date) : string
    {
     
     // var MyTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      //console.log(MyTimeZone);
      
    var m = moment(m_date);
    var s = m.format("h:mm:ss(.SSS)a") + " " + Utilities.sTimeZone;

    //var zone = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
   
    return(s);
    }

    /*   -----------------------------------------------------------------   */

    static GetEndTime(bCCYYMMDD? : boolean) : number
    {
      if (bCCYYMMDD == true)
        {
        let m = moment(Date.now());
        let s = m.format("yyyyMMDD");
        return(Number.parseInt(s));
        }
      else  
        return( Math.trunc(Date.now() / 1000) + 60);
    }

    /*   -----------------------------------------------------------------   */

    static GetSsboeNow() : number
    {
    return( Math.trunc(Date.now() / 1000) );
    }

    /*   -----------------------------------------------------------------   */

    static GetDateFromSsboe(iSsboe : number) : string
    {
      return( new Date(iSsboe * 1000).toString())
    }

    /*   -----------------------------------------------------------------   */

    static formatTimeNoDay(m_date) : string
    {
     
     // var MyTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      //console.log(MyTimeZone);
      
    var m = moment(m_date);
    var s = m.format("h:mm:ssa") + " " + Utilities.sTimeZone;

    //var zone = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
   
    return(s);
    }

    /*   -----------------------------------------------------------------   */

    static formatTime(m_date) : string
    {
     
     // var MyTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      //console.log(MyTimeZone);
      
    var m = moment(m_date);
    var s = m.format("ddd h:mm:ssa") + " " + Utilities.sTimeZone;

    //var zone = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
   
    return(s);

    var ampm;
    var hours   = m_date.getHours();
    var minutes = m_date.getMinutes();
    var seconds = m_date.getSeconds();

    if (minutes < 10)
    minutes = '0' + minutes;

    if (seconds < 10)
    seconds = '0' + seconds;

    if (hours > 12)
    {
    hours = hours - 12;
    ampm  = "pm ";
    }
    else
    ampm  = "am ";

    //if (hours < 10)w
    //  hours = '0' + hours;

    var time  =  hours + ":" + minutes + ":" + seconds + ampm + 
                m_date.toLocaleTimeString(undefined, 
                {day:'2-digit',timeZoneName: 'short'}).substring(4);


    return time.toString();
    }

    /*   -----------------------------------------------------------------   */

    static formatTimeStatusbar(m_date : number) : string
    {
    var m = moment(m_date);
    var s = m.format("ddd DD MMM h:mm:ssa") + " " + Utilities.sTimeZone;

    return(s);
    }

    /*   -----------------------------------------------------------------   */

    static getModeColor(m_mode : string | undefined) : string
    {
      if (!m_mode)
        return("grey");

      switch(m_mode.toUpperCase())
      {
      case "SOC":
      case "PREOPEN":
      case "PRE-OPEN":
      case "TRANSIENT":
      case "IBO":
      case "IAO":
      case "EOC":
      case "PRICE_LMIT_ENABLED":
      case "PRICE_LIMIT_ENABLED":
      case "PRECLOSE":
      case "RESTRICTED_OPEN":
      case "QSM_MODE1":
      case "QSM_MODE2":
      case "QSM_MODE3":
      case "NO CANCEL":
      case "PRICE INDICATION":
        return("orange");
    
      case "OPEN":
      case "NORMAL":
               case "LATE TRADING":
               case "EARLY TRADING":
        return(FontInfo.sGreen);
    
      case "EOD":
      case "END OF DAY":
      case "CLOSED":
               case "SETTLED":
        return("red");
    
      case "FORBIDDEN":
      case "INTRRUPTED":
      case "PRE CROSS":
      case "PRE CLOSE":
      case "PRE-CLOSE":
      case "CROSS":
    
      case "UNDEFINED":
      case "SUSPENDED":
      case "UNAVAILABLE":
      case "EXPIT_BLOCK_OPEN":
      case "EXPIT_EXTENDED_OPEN":
      case "HALTED":
    
      case "EXPIRED":
      case "UNKNOWN":
      case "INVALID":
        return("grey");
    
      default:
        return("grey");
      }  
    }

};